"use client";
import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils/utils";
import Link from "next/link";

interface ActionCircleButtonProps {
  text?: string;
  slug?: string;
  href?: string;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  isVisible?: boolean;
}

const ActionCircleButton = ({
  text = "Case Study",
  slug,
  href,
  className,
  iconClassName,
  textClassName,
  isVisible = true,
}: ActionCircleButtonProps) => {
  const finalHref = href || `/case-study/${slug}`;

  const hidden = { opacity: 0, scale: 0.2, x: "-50%", y: "-50%" };
  const shown = { opacity: 1, scale: 1, x: "-50%", y: "-50%" };

  return (
    <motion.div
      initial={hidden}
      animate={isVisible ? shown : hidden}
      exit={hidden}
      transition={{
        duration: 0.4,
        type: "spring",
        stiffness: 200,
        damping: 20,
      }}
      style={{ pointerEvents: isVisible ? "auto" : "none" }}
      inert={!isVisible}
      className={cn(
        "flex flex-col items-center justify-center absolute top-1/2 left-1/2 cursor-pointer",
        "lg:w-50.5 lg:h-50.5 w-30 h-30 rounded-full",
        "bg-white/20 backdrop-blur-md",
        "shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] z-20 group",
        className,
      )}
    >
      {" "}
      <Link
        href={finalHref}
        className="flex flex-col items-center justify-center"
      >
        <ArrowUpRight
          className={cn(
            "text-accent-foreground lg:w-10 w-6 lg:h-10 h-6 mb-1 relative font-black",
            "group-hover:rotate-45 transition-transform duration-700",
            iconClassName,
          )}
        />
        <span
          className={cn(
            "text-accent-foreground font-black tracking-widest uppercase text-xs lg:text-lg drop-shadow-sm",
            textClassName,
          )}
        >
          {text}
        </span>
      </Link>
    </motion.div>
  );
};

export default ActionCircleButton;
